module.exports = __webpack_public_path__ + "img/cartas2.903b54b6.jpeg";